import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Store } from '@ngrx/store';

import { helpers } from '../../helpers';
import {
  PageEventsHandler,
  Utils,
  Translate, SocketHandler
} from '../../services';
import {
  AssessmentService,
  AssessmentActions,
  UserService,
  ViewActions,
  ViewService
} from '../../logics';
import {
  REQUEST_FULLSCREEN,
  CHECK_DEV_TOOLS,
  TERMINATE_OUT_OF_FULLSCREEN_IN_SECS,
  COUNT_DOWN_AT_FULLSCREEN_EXIT,
  NUMBER_OF_EXIT_ALLOWED,
  FREE_INSERT_MODE,
  TRAINING_MODE,
  DEFAULT_PROFILE_PICTURE,
  WAITING_BEFORE_START,
  MULTIPLE_REQUESTS, TIMEOUT_IDLE_LOGIN, WELCOME_PAGE
} from '../../constants';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'wait-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cs-simple-page">
      <div [ngSwitch]="waitMode$ | async">
        <div
            class="cs-simple-page__content"
            *ngSwitchCase="'initial'">
          <p class="cs-simple-page__text">
            {{ (translations$ | async)['wait#welcome_line_1'] }}
          </p>
          <p
              class="cs-simple-page__text"
              *ngIf="!trainingMode">
            {{ (translations$ | async)['wait#welcome_line_2'] }}
          </p>
          <p>
            <strong>{{ (translations$ | async)['wait#nb_intro'] }}</strong>
            {{ (translations$ | async)['wait#nb_description'] }}
          </p>
          <div
              class="cs-form-warning-message"
              *ngIf="showSocketWarningMessage && !inhibitConnectionProblemMessage"
          >
            <div>
              {{ (translations$ | async)['login#connection_error_line0'] }}
            </div>
            <div>
              {{ (translations$ | async)['login#connection_error_line1'] }}
            </div>
          </div>
          <div class="cs-form-btn-group">
            <button
                class="cs-btn cs-btn-cta cs-btn-xl"
                turnOnFullscreen>
              {{ (translations$ | async)['wait#welcome_submit']}}
            </button>
          </div>
        </div>

        <div
            class="cs-simple-page__content"
            *ngSwitchCase="'freeze'">
          <p
              class="cs-simple-page__text"
              *ngIf="useCountDown && !isEnded">
            {{ (translations$ | async)['wait#restore_test_line_1'] }} {{ leftTime$ | async }}
            {{ (translations$ | async)['wait#restore_test_line_2']}}
          </p>
          <p
              class="cs-simple-page__text alert"
              *ngIf="!useCountDown && !freeInsert && !isEnded">
            {{ (translations$ | async)['wait#restore_test_without_count'] }}
          </p>
          <div class="cs-form-btn-group">
            <button
                class="cs-btn cs-btn-cta cs-btn-xl"
                turnOnFullscreen>
              {{ (translations$ | async)['wait#restore_submit']}}
            </button>
          </div>
        </div>

        <div
            class="cs-simple-page__content"
            *ngSwitchCase="'locked'">
          <p class="cs-simple-page__text">
            {{ (translations$ | async)['wait#test_locked']}}
          </p>
          <button
              class="cs-btn cs-btn-cta cs-btn-xl cs-btn-start-test"
              (click)="refreshPageClick()">
            {{ (translations$ | async)['wait#back_to_login']}}
          </button>
        </div>

        <div
            class="cs-simple-page__content"
            *ngSwitchCase="'ready'">

          <div class="cs-simple-page__user-data-wrapper">
            <img id="big-pp"
                 class="cs-simple-page__user-thumb"
                 *ngIf="!trainingMode"
                 [alt]="shared.userData?.name"
                 [src]="profilePicture"
            >

            <p
                class="cs-simple-page__text-small cs-simple-page__user-data-text"
                *ngIf="!trainingMode && shared.userData?.name">
              {{ (translations$ | async)['wait#welcome_greetings_name'] }}: <strong>{{ shared.userData?.name }}</strong><br />
              {{ (translations$ | async)['wait#welcome_greetings_birthday'] }}: <strong>{{ shared.userData?.birthday }}</strong><br />
              {{ (translations$ | async)['wait#welcome_greetings_birth_place'] }}: <strong>{{ shared.userData?.birthPlace }}</strong><br />
              {{ (translations$ | async)['wait#welcome_greetings_cod_fisc'] }}: <strong>{{ shared.userData?.codFisc }}</strong>
            </p>
          </div>

          <p
              class="cs-simple-page__text cs-simple-page__text-not-started"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="!wasStarted && !trainingMode">
            {{ (translations$ | async)['wait#welcome_greetings_line_2a'] }}
          </p>
          <p
              class="cs-simple-page__text cs-simple-page__text-not-started"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="!wasStarted && !trainingMode">
            {{ (translations$ | async)['wait#welcome_greetings_line_2b'] }}
          </p>
          <p
              class="cs-simple-page__text cs-simple-page__text-not-started"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="!wasStarted && !trainingMode">
            {{ (translations$ | async)['wait#welcome_greetings_line_2c'] }}
          </p>
          <p
              class="cs-simple-page__text"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="wasStarted && !isEnded">
            {{ (translations$ | async)['wait#welcome_greetings_line_2a_res'] }}
          </p>
          <p
              class="cs-simple-page__text"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="wasStarted && !isEnded">
            {{ (translations$ | async)['wait#welcome_greetings_line_2_res'] }}
          </p>
          <p
              class="cs-simple-page__text"
              [ngClass]="{
              'cs-capitalize': trainingMode
            }"
              *ngIf="isEnded">
            {{ (translations$ | async)['wait#welcome_greetings_line_2_ris'] }}
          </p>
          <p class="cs-simple-page__text" *ngIf="trainingMode">
            <img src="assets/img/logo.png"/>
          </p>
          <p
              class="cs-simple-page__text"
              [ngClass]="{'cs-capitalize': trainingMode}"
              *ngIf="trainingMode">
            <br />
            {{ (translations$ | async)['wait#welcome_greetings_line_tr_2a'] }}
            <br /><br />
          </p>
          <div *ngIf="!trainingMode" class="cs-simple-page__iframe-container">
            <iframe class="avvertenze" [src]="avvertenzeSrc" #iframe></iframe>
            <div class="cs-simple-page__iframe-overlay" (scroll)="iframeOverlayScroll($event)" #iframeOverlay>
              <div class="cs-simple-page__iframe-scroll-overlay-inner" #iframeOverlayInner>&nbsp;</div>
            </div>
            <div class="cs-simple-page__iframe-scroll-trigger-container">
              <div class="cs-simple-page__iframe-scroll-trigger" (click)="iframeScrollClick($event)">&nbsp;</div>
            </div>
          </div>

          <div class="cs-form-btn-group">
            <button
                class="cs-btn cs-btn-cta cs-btn-xl cs-btn-start-test"
                [ngClass]="{
                'cs-btn-loader': isLoading,
                'disabled': !((!multipleRequests && canStartTest) || (multipleRequests && canStartTest && mrIsFirstRicettaAvailable) || (multipleRequests && canStartTest && isCompleted)) || (assessmentError$ | async)
              }"
                (click)="startTestClick()">
              <span *ngIf="!canStartTest">{{startCountdownText$ | async}}</span>
              <span *ngIf="canStartTest">
              {{ isLoading ? '' : !isEnded
                ? wasStarted
                    ? (mrIsFirstRicettaAvailable || !multipleRequests) ? (translations$ | async)['wait#welcome_greetings_submit_res'] : (translations$ | async)['wait#welcome_greetings_submit_section_loading']
                    : (mrIsFirstRicettaAvailable || !multipleRequests) ? (translations$ | async)['wait#welcome_greetings_submit'] : (translations$ | async)['wait#welcome_greetings_submit_section_loading']
                : (translations$ | async)['wait#welcome_greetings_submit_ris']
              }}
				      </span>
              <div
                  class="cs-loader"
                  *ngIf="isLoading">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
})

export class WaitComponent implements OnInit, OnDestroy {
  @ViewChild('iframe') iframe: ElementRef;
  @ViewChild('iframeOverlay') iframeOverlay: ElementRef;
  @ViewChild('iframeOverlayInner') iframeOverlayInner: ElementRef;
  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    this.setIframeOverlayHeight();
  }
  avvertenzeSrc;
  useCountDown = COUNT_DOWN_AT_FULLSCREEN_EXIT;
  secBeforeLock: number = Math.round(TERMINATE_OUT_OF_FULLSCREEN_IN_SECS);
  numberOfExitAllowed: number = NUMBER_OF_EXIT_ALLOWED;
  freeInsert: boolean = FREE_INSERT_MODE;
  trainingMode: boolean = TRAINING_MODE;
  isLoading: boolean = false;
  isLoading$: Observable<boolean>;
  isModalActive$: Observable<boolean>;
  wasStarted: boolean = false;
  isEnded: any = false;

  initial$: Observable<boolean>;
  locked$: Observable<boolean>;
  readyToStart$: Observable<boolean>;
  freeze$: Observable<boolean>;
  backToLogin$: Observable<boolean>;
  backToTest$: Observable<boolean>;
  assessmentLoadedStatus$: Observable<boolean>;
  isLogged$: Observable<boolean>;
  isFullscreen$: Observable<boolean>;

  waitMode$: Observable<string>;
  countdown$: Observable<number>;
  leftTime$: Observable<number>;
  startTimeCountdown$: Observable<Date>;
  nothingMore$: Observable<any>;
  isFullscreenAndLogged$: Observable<any>;
  translations$: Observable<any>;
  assessmentError$: Observable<any>;
  startCountdownText$: Subject<number> = new Subject<number>();

  startTest$: Subject<any> = new Subject<any>();
  destroyed$: Subject<any> = new Subject<any>();

  canStartTest: boolean = false;
  isCompleted: boolean = false;

  mrIsFirstRicettaAvailable: boolean = false;
  multipleRequests = MULTIPLE_REQUESTS;

  showSocketWarningMessage: boolean = false;
  inhibitConnectionProblemMessage: boolean = false;
  requestFullscreen: boolean;

  @Input() shared: Object;
  @Output() viewChange = new EventEmitter<string>();

  profilePicture;

  constructor(
    private store: Store<any>,
    private viewActions: ViewActions,
    private viewService: ViewService,
    private userService: UserService,
    private assessmentActions: AssessmentActions,
    private assessmentService: AssessmentService,
    private pageEventsHandler: PageEventsHandler,
    private utils: Utils,
    private translate: Translate,
    private sanitizer: DomSanitizer,
    private chRef: ChangeDetectorRef,
    private socketHandler: SocketHandler
  ) {
    this.requestFullscreen = REQUEST_FULLSCREEN && this.utils.isWeb();

    this.userService.getLanguage$().subscribe((lang) => {
      let src = 'assets/avvertenze/avvertenze_' + lang + '.html?ts=' + (new Date()).getTime();
      this.avvertenzeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    });

    this.translations$ = this.translate.getTranslations$();
    this.assessmentError$ = this.assessmentService.getAssessmentError$();

    this.isLoading$ = this.userService.isLoading$();
    this.isModalActive$ = this.viewService.isModalVisible$();
    this.isLogged$ = this.userService.isLogged$();
    this.isFullscreen$ = this.viewService.isFullscreen$()
      .map(isFullscreen => this.requestFullscreen
        ? isFullscreen : true)
      .distinctUntilChanged();
    this.isFullscreenAndLogged$ = this.isFullscreen$
      .withLatestFrom(this.isLogged$);

    this.nothingMore$ = Observable.merge(
      this.destroyed$,
      this.assessmentService
        .isLocked$()
        .filter(isLocked => isLocked));

    this.locked$ = this.assessmentService.isLocked$();

    this.initial$ = this.isFullscreenAndLogged$
      .map(([isFullscreen, isLogged]) => !isLogged && !isFullscreen);

    this.readyToStart$ = this.isFullscreenAndLogged$
      .withLatestFrom(this.assessmentService.isStarted$())
      .map(([[isFullscreen, isLogged], isStarted]) =>
        isLogged && isFullscreen && !isStarted);

    this.freeze$ = this.isFullscreenAndLogged$
      .map(([isFullscreen, isLogged]) => isLogged && !isFullscreen);

    this.backToTest$ = this.isFullscreenAndLogged$
      .withLatestFrom(this.assessmentService.isStarted$())
      .map(([[isFullscreen, isLogged], isStarted]) =>
        isLogged && isFullscreen && isStarted)
      .filter(doIt => doIt);

    this.backToLogin$ = this.isFullscreenAndLogged$
      .map(([isFullscreen, isLogged]) => !isLogged && isFullscreen)
      .filter(doIt => doIt);

    this.waitMode$ = Observable
      .combineLatest(this.locked$, this.initial$, this.readyToStart$, this.freeze$)
      .map(([locked, initial, ready, freeze]) => locked
        ? 'locked' : initial
          ? 'initial' : ready
            ? 'ready' : freeze
              ? 'freeze' : 'unknow');

    this.countdown$ = this.utils.resettableTimer$(this.freeze$)
      .takeWhile((x) => x <= this.secBeforeLock - 1);

    this.startTimeCountdown$ = this.countdown$
      .filter(x => x === 0)
      .map(() => new Date());

    this.leftTime$ = this.countdown$
      .withLatestFrom(this.startTimeCountdown$)
      .map(([, start]) =>
        this.secBeforeLock - helpers.differenceInSecondsBetweensDates(start, new Date()) - 1)
      .startWith(this.secBeforeLock);

    Observable.timer(0, 1000).take(WAITING_BEFORE_START + 1).subscribe({
      next: tick => {
        this.startCountdownText$.next(WAITING_BEFORE_START - tick);
      },
      complete: () => {
        this.canStartTest = true;
        this.chRef.detach();
        Observable.timer(0, 100).take(1).subscribe((tick) => {
          this.chRef.detectChanges();
          this.chRef.reattach();
        });
      },
      error: err => {}
    });

    this.lockControl$()
      .takeUntil(this.destroyed$)
      .withLatestFrom(this.isLoading$)
      .withLatestFrom(this.isModalActive$)
      .subscribe(([[idle, isLoading], isModalActive]) => {
        let user;
        this.userService.getUser$().subscribe((loadedUser) => {
          user = loadedUser;
        });
        // Load welcome page.
        if (isLoading || isModalActive || typeof user !== 'undefined') {
          //console.log("isLoading or isModalActive, nothing to do");
          return;
        }
        this.inhibitConnectionProblemMessage = true;
        // fix tablet
        let welcomePage = WELCOME_PAGE;
        if(this.utils.isMobile() || this.utils.isDesktop()){
          welcomePage = 'welcome_local.html';
        }
        document.location.href = welcomePage;
        //this.store.dispatch(this.assessmentActions.lockTest());
      });
  }

  lockControl$(): Observable<any> {
    const newTimer = () => Observable.timer(TIMEOUT_IDLE_LOGIN);
    const mouseMove = Observable.fromEvent(document.body, 'mousemove')
      .startWith("loaded")
      .throttleTime(250);

    return mouseMove.switchMapTo(newTimer());
  }

  startTestClick() {
    if ((!MULTIPLE_REQUESTS && this.canStartTest) || (MULTIPLE_REQUESTS && this.canStartTest && this.mrIsFirstRicettaAvailable) || (MULTIPLE_REQUESTS && this.canStartTest && this.isCompleted)) {
      this.startTest$.next();
    }
  }

  refreshPageClick() {
    if(<any>WELCOME_PAGE === 'index.php'){
      // fix tablet
      let welcomePage = WELCOME_PAGE;
      if(this.utils.isMobile() || this.utils.isDesktop()){
        welcomePage = 'welcome_local.html';
      }
      document.location.href = welcomePage;
    } else {
      document.location.reload(true);
    }
  }

  getProfilePictureUrl(profileImage) {
    if (typeof profileImage !== 'undefined' &&
      profileImage !== null &&
      profileImage.length > 0) {
      return 'data:image/jpg;base64,' + profileImage;
    }
    return ''+DEFAULT_PROFILE_PICTURE;
  }

  ngOnInit() {
    this.assessmentService.isMRFirstAvailableSectionLoaded$()
      .takeUntil(this.destroyed$)
      .subscribe((isAvailable) => {
        this.mrIsFirstRicettaAvailable = isAvailable;
        this.chRef.detach();
        Observable.timer(0, 100).take(1).subscribe((tick) => {
          this.chRef.detectChanges();
          this.chRef.reattach();
        });
      });

    this.assessmentError$
      .takeUntil(this.destroyed$)
      .subscribe(() => this.isLoading = false);

    this.backToTest$
      .takeUntil(this.nothingMore$)
      .subscribe(() => this.store
        .dispatch(this.viewActions.changeView(this.isEnded ? 'report' : 'survey')));

    this.backToLogin$
      .takeUntil(this.nothingMore$)
      .subscribe(() => this.store.dispatch(this.viewActions.changeView('login')));

    this.leftTime$
      .filter(left => left < 1)
      .filter(() => this.useCountDown)
      .filter(() => !this.freeInsert)
      .filter(() => !this.isEnded)
      .take(1)
      .takeUntil(this.destroyed$)
      .subscribe(x =>
        this.store.dispatch(this.assessmentActions.lockTest()));

    this.startTest$
      .filter(() => {
        return !this.isLoading || this.mrIsFirstRicettaAvailable
      })
      .filter(() => !CHECK_DEV_TOOLS || CHECK_DEV_TOOLS && !this.pageEventsHandler.areDevToolsOpen())
      .do(() => this.isLoading = true)
      .delayWhen(() => {
        if (!MULTIPLE_REQUESTS) {
          return this.assessmentService.isLoaded$()
        }
        return this.assessmentService.isMRFirstAvailableSectionLoaded$()
      })
      .withLatestFrom(this.isFullscreen$)
      .filter(([, isFullscreen]) => {
        if (!isFullscreen) {
          this.isLoading = false;
        }

        return isFullscreen;
      })
      .takeUntil(this.assessmentError$)
      .takeUntil(this.nothingMore$)
      .subscribe(() => !this.isEnded
        ? this.store.dispatch(this.assessmentActions.startTest())
        : this.store.dispatch(this.viewActions.changeView('report')));

    this.assessmentService.getProgress$()
      .pluck('sections')
      .takeUntil(this.destroyed$)
      .subscribe(sections => {
        this.wasStarted = Object.keys(sections).length > 0;
        if (this.wasStarted) {
          this.canStartTest = true;
        }
      });

    this.assessmentService.getProgress$()
      .pluck('terminated')
      .takeUntil(this.destroyed$)
      .subscribe(terminated =>
        this.isEnded = terminated);

    this.freeze$
      .filter(freeze => freeze)
      .withLatestFrom(this.assessmentService.getFreezeCount$())
      .takeUntil(this.destroyed$)
      .subscribe(([, freezeCounter]) => {
        let currentCount = freezeCounter + 1;
        this.store.dispatch(this.assessmentActions.interruptAttemp());
        this.store.dispatch(this.assessmentActions.incrementFreezeCount());

        if (!this.useCountDown &&
          currentCount >= this.numberOfExitAllowed &&
          !this.freeInsert && !this.isEnded) {
          this.store.dispatch(this.assessmentActions.lockTest());
        }
      });

    let pp = typeof this.shared['userData'] !== 'undefined' && this.shared['userData'].profileImage !== 'undefined' ? this.shared['userData'].profileImage : undefined;
    let ppp = this.getProfilePictureUrl(pp);
    this.profilePicture = this.sanitizer.bypassSecurityTrustResourceUrl(ppp);

    this.socketHandler.connect$
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.showSocketWarningMessage = !this.socketHandler.isConnected;
        this.chRef.detach();
        Observable.timer(0, 10).take(1).subscribe((tick) => {
          this.chRef.detectChanges();
          this.chRef.reattach();
        });
      });

    this.socketHandler.disconnect$
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.showSocketWarningMessage = !this.socketHandler.isConnected;
        this.chRef.detach();
        Observable.timer(0, 10).take(1).subscribe((tick) => {
          this.chRef.detectChanges();
          this.chRef.reattach();
        });
      });

    Observable.timer(1000, 200)
      .take(1)
      .subscribe(() => {
        this.showSocketWarningMessage = !this.socketHandler.isConnected;
        this.chRef.detectChanges();
        this.chRef.detach();
        Observable.timer(0, 10).take(1).subscribe((tick) => {
          this.chRef.detectChanges();
          this.chRef.reattach();
        });
      });

    this.assessmentService.isCompleted$()
      .takeUntil(this.destroyed$)
      .subscribe(completed => this.isCompleted = completed);
  }

  ngAfterViewInit(){
    this.setIframeOverlayHeight();
  }

  setIframeOverlayHeight(){
    if(this.trainingMode) return;

    const loaded$ = new Subject();
    const minHeight = 300;

    Observable.timer(0, 500)
      .takeUntil(loaded$)
      .take(5) // max attempts
      .subscribe(() => {
        if(!this.iframe) return;

        let iframeWindow = this.iframe.nativeElement.contentWindow;
        let scrollHeight = iframeWindow.document.body ? iframeWindow.document.body.scrollHeight : 0;
        if(scrollHeight > minHeight){
          this.iframeOverlayInner.nativeElement.style.height = scrollHeight + 'px';
          loaded$.next();
        }
      });
  }

  iframeOverlayScroll(ev){
    let iframeWindow = this.iframe.nativeElement.contentWindow;
    let scrollTop = ev.target.scrollTop;
    iframeWindow.scrollTo(0, scrollTop);
  }

  iframeScrollClick(ev){
    let delta = 300; // iframe height pixels
    let iframeWindow = this.iframe.nativeElement.contentWindow;
    // let scrollTo = iframeWindow.scrollY + delta;
    // iframeWindow.scrollTo(0, scrollTo);
    this.iframeOverlay.nativeElement.scrollTo(0, iframeWindow.scrollY + delta);
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/wait/wait.component.ts